var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.707 12.707L17.293 11.293 13 15.586 13 6 11 6 11 15.586 6.707 11.293 5.293 12.707 12 19.414z"}));
}

Down.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Down;

Down.default = Down;
